class Storage {

    constructor(){
        this.cache=new Map();
        this.pageData=new Map();
    }

    setPageData(key,data){
        console.log(key,data)
        this.pageData.set(key,data)
    }

    getPageData(key){
        console.log(key)
        return this.pageData.get(key);
    }

    clearPageData(){
        return this.pageData.clear();
    }

    setCache(key,data){
        this.cache.set(key,data);
    }

    getCache(key){
        return this.cache.get(key);
    }

    get(key){
        let data=this.cache.get(key);
        if(!data){
            data=JSON.parse(localStorage.getItem(key));
            if(data){
                this.cache.set(key,data);
            }
        }
        return data;
    }

    set(key,data){
        if(!data){
            this.remove(key);
            return;
        }
        this.cache.set(key,data);
        localStorage.setItem(key,JSON.stringify(data))
    }

    remove(key){
        this.cache.set(key,null);
        localStorage.removeItem(key);
    }

    clear(){
        this.cache.clear();
        localStorage.clear();
    }

}


export const storage=new Storage();

export const MENU_MAP_KEY='menu-map';
export const SYS_KEY='sys';
export const ORG_KEY='org';
export const USER_KEY='user';


export const getMenuMap=()=>{
    return storage.getCache(MENU_MAP_KEY);
}

export const saveMenuMap=(data)=>{
    return storage.setCache(MENU_MAP_KEY,data);
}

export const hasMenu=(path)=>{
    let map=getMenuMap();
    return map && map.get(path);
}

export const getMenu=(path)=>{
    let map=getMenuMap();
    if(map)
        return map.get(path);
    return null;
}

export const getSys=()=>{
    return storage.get(SYS_KEY);
}

export const saveSys=(data)=>{
    return storage.set(SYS_KEY,data);
}

export const getOrg=()=>{
    return storage.get(ORG_KEY);
}

export const saveOrg=(data)=>{
    return storage.set(ORG_KEY,data);
}


export const getUser=()=>{
    return storage.get(USER_KEY);
}

export const saveUser=(data)=>{
    return storage.set(USER_KEY,data);
}






